// Create a new file for antd theme configuration
export const antdTheme = {
	token: {
		// // Primary color (used for buttons, links, etc.)
		// colorPrimary: '#2f54eb', // Your navy color
	
		// colorText: '#2b2d33', // Your grey
		// colorTextSecondary: '#3e4149', // Your navy

		colorPrimary: '#2f54eb', // keeping as requested
		colorSuccess: '#10b981', // using your success color
		colorWarning: '#f59e0b', // using your accent color
		colorError: '#ef4565', // using your red color
	},
	components: {
		// Button: {
		// 	// Customize button specifically
		// 	// colorPrimary: '#094067',
		// 	// algorithm: true, // Enable algorithm to generate hover/active states
		// },
		// Input: {
		// 	// Customize inputs
		// 	colorBorder: '#f59e0b',
		// 	colorBorderHover: '#3da9fc',
		// },
		// Select: {
		// 	// Customize selects
		// 	colorBorder: '#f59e0b',
		// 	colorBorderHover: '#3da9fc',
		// },
		// Table: {
		// 	// Customize tables
		// 	colorBorderSecondary: '#f59e0b',
		// },
	},
};
